<template>
  <v-container fluid>
    <v-row wrap align-center>
      <v-col cols=12>
        <div class="text-center">
          <h1 class="headline font-weight-medium">
            {{ $vuetify.lang.t(`$vuetify.legalInformation.title`) }}
          </h1>
        </div>
        <v-divider class="my-3"></v-divider>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="8" offset-md="2" cols="12">
        <v-card tile>
          <v-card-text class="subtitle-1 black--text">
            <div v-html="$vuetify.lang.t(`$vuetify.legalInformation.header`)"></div>

            <h2>{{ $vuetify.lang.t(`$vuetify.legalInformation.informationCollection.title`) }}</h2>
            <div class="my-3"
                 v-html="$vuetify.lang.t(`$vuetify.legalInformation.informationCollection.subheader`)"></div>

            <h3>{{ $vuetify.lang.t(`$vuetify.legalInformation.informationCollection.dataTypes.title`) }}</h3>

            <h4 class="my-2">{{
              $vuetify.lang.t(`$vuetify.legalInformation.informationCollection.dataTypes.personalData.title`) }}</h4>
            <div class="my-3"
                 v-html="$vuetify.lang.t(`$vuetify.legalInformation.informationCollection.dataTypes.personalData.description`)"></div>
            <ul>
              <li v-for="item in 5" :key="item">
                {{ $vuetify.lang.t(`$vuetify.legalInformation.informationCollection.dataTypes.personalData.list[${item -
                1}]`) }}
              </li>
            </ul>

            <h4 class="my-2">{{ $vuetify.lang.t(`$vuetify.legalInformation.informationCollection.usageData.title`)
              }}</h4>
            <div class="my-3"
                 v-html="$vuetify.lang.t(`$vuetify.legalInformation.informationCollection.usageData.description`)"></div>

            <h2 class="my-2">{{ $vuetify.lang.t(`$vuetify.legalInformation.useOfData.title`) }}</h2>
            <div class="my-3" v-html="$vuetify.lang.t(`$vuetify.legalInformation.useOfData.description`)"></div>
            <ul>
              <li v-for="item in 6" :key="item">
                {{ $vuetify.lang.t(`$vuetify.legalInformation.useOfData.list[${item - 1}]`) }}
              </li>
            </ul>

            <h2 class="my-2">{{ $vuetify.lang.t(`$vuetify.legalInformation.transferOfData.title`) }}</h2>
            <div class="my-3" v-html="$vuetify.lang.t(`$vuetify.legalInformation.transferOfData.description`)"></div>

            <h2 class="my-2">{{ $vuetify.lang.t(`$vuetify.legalInformation.disclosureOfData.title`) }}</h2>
            <h3 class="my-2">{{ $vuetify.lang.t(`$vuetify.legalInformation.disclosureOfData.legalRequirements.title`)
              }}</h3>
            <div class="my-3"
                 v-html="$vuetify.lang.t(`$vuetify.legalInformation.disclosureOfData.legalRequirements.description`)"></div>
            <ul v-if="$vuetify.lang.current !== 'ru'">
              <li v-for="item in 5" :key="item">
                {{ $vuetify.lang.t(`$vuetify.legalInformation.disclosureOfData.legalRequirements.list[${item - 1}]`) }}
              </li>
            </ul>

            <h2 class="my-2">{{ $vuetify.lang.t(`$vuetify.legalInformation.securityOfData.title`) }}</h2>
            <div class="my-3" v-html="$vuetify.lang.t(`$vuetify.legalInformation.securityOfData.description`)"></div>

            <h3 class="my-2">{{ $vuetify.lang.t(`$vuetify.legalInformation.securityOfData.cookieInformation.title`)
              }}</h3>
            <div class="my-3"
                 v-html="$vuetify.lang.t(`$vuetify.legalInformation.securityOfData.cookieInformation.description`)"></div>
            <div class="my-3"
                 v-html="$vuetify.lang.t(`$vuetify.legalInformation.securityOfData.cookieInformation.listTitle`)"></div>
            <ul>
              <li v-for="item in 2" :key="item">
                <div
                  v-html="$vuetify.lang.t(`$vuetify.legalInformation.securityOfData.cookieInformation.list[${item - 1}]`)"></div>
              </li>
            </ul>

            <h3 class="my-2">{{ $vuetify.lang.t(`$vuetify.legalInformation.securityOfData.geographicInformation.title`)
              }}</h3>
            <div class="my-3"
                 v-html="$vuetify.lang.t(`$vuetify.legalInformation.securityOfData.geographicInformation.description`)"></div>
            <ul>
              <li v-for="item in 1" :key="item">
                <div
                  v-html="$vuetify.lang.t(`$vuetify.legalInformation.securityOfData.geographicInformation.list[${item - 1}]`)"></div>
              </li>
            </ul>

            <h3 class="my-2">{{ $vuetify.lang.t(`$vuetify.legalInformation.securityOfData.analytics.title`) }}</h3>
            <div class="my-3"
                 v-html="$vuetify.lang.t(`$vuetify.legalInformation.securityOfData.analytics.description`)"></div>
            <ul>
              <li v-for="item in 1" :key="item">
                <div
                  v-html="$vuetify.lang.t(`$vuetify.legalInformation.securityOfData.analytics.list[${item - 1}]`)"></div>
              </li>
            </ul>

            <h2 class="my-2">{{ $vuetify.lang.t(`$vuetify.legalInformation.linksToOtherSites.title`) }}</h2>
            <div class="my-3" v-html="$vuetify.lang.t(`$vuetify.legalInformation.linksToOtherSites.description`)"></div>

            <h2 class="my-2">{{ $vuetify.lang.t(`$vuetify.legalInformation.childrenPrivacy.title`) }}</h2>
            <div class="my-3" v-html="$vuetify.lang.t(`$vuetify.legalInformation.childrenPrivacy.description`)"></div>

            <h2 class="my-2">{{ $vuetify.lang.t(`$vuetify.legalInformation.changesToThisPrivacyPolicy.title`) }}</h2>
            <div class="my-3"
                 v-html="$vuetify.lang.t(`$vuetify.legalInformation.changesToThisPrivacyPolicy.description`)"></div>

            <h2 class="my-2">{{ $vuetify.lang.t(`$vuetify.legalInformation.contactUs.title`) }}</h2>
            <div class="my-3" v-html="$vuetify.lang.t(`$vuetify.legalInformation.contactUs.description`)"></div>
            <ul>
              <li v-for="item in 1" :key="item">
                <div v-html="$vuetify.lang.t(`$vuetify.legalInformation.contactUs.list[${item - 1}]`)"></div>
              </li>
            </ul>

          </v-card-text>

        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import backend from '@/backend'
import { firePrerenderEvent, isPrerendered } from '../utils/prerender'
import metaMixin from '../mixins/metaMixin'
import snackbarMixin from '../mixins/snackbarMixin'

export default {
  name: 'LegalInformation',
  mixins: [metaMixin, snackbarMixin],
  methods: {
    async getProfile () {
      try {
        await backend.getUserProfile() // just plain user profile retrieving from server

        // for prerender
        if (isPrerendered()) {
          this.$nextTick(() => firePrerenderEvent())
        }
      } catch (e) {
        this.processFailedRequest(e)
      }
    }
  },
  async beforeRouteUpdate () {
    await this.getProfile()
  },
  beforeRouteEnter (to, from, next) {
    next(async vm => {
      await vm.getProfile()
    })
  },
  metaInfo: {
    title: 'Drive Safely | Privacy Policy',
    meta: [
      { name: 'description', content: 'Drive Safely Privacy Policy about cookies and permissions' },
      { property: 'og:title', content: 'Drive Safely Privacy Policy' },
      { property: 'og:site_name', content: 'Drive Safely' },
      { property: 'og:description', content: 'Drive Safely Privacy Policy about cookies and permissions' },
      { property: 'og:url', content: 'https://mobiledrivesafely.com/legal_information' }
    ]
  }
}
</script>

<style scoped>

</style>
